import { DefinedColumns } from '@vindr/services/interfaces';
import { useGetProcedures } from '@vindr/services/actions/procedure.api';
import { useTranslation } from 'react-i18next';

interface ProcedureSearchColumnsType
  extends DefinedColumns<ReturnType<typeof useGetProcedures>['data']['data'][number]> {}

const useProcedureSearchColumns = (): ProcedureSearchColumnsType[] => {
  const { t } = useTranslation('Vindoc');

  return [
    {
      title: t('Procedure Code'),
      width: 80,
      dataIndex: 'code',
      key: 'code',
      ellipsis: true,
    },
    {
      title: t('Procedure Name'),
      width: 250,
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
    },
    {
      title: t('Modality'),
      width: 50,
      dataIndex: 'modality',
      key: 'modality',
      ellipsis: true,
    },
    {
      title: t('Institution'),
      width: 170,
      dataIndex: ['institution', 'name'],
      key: 'institution',
      ellipsis: true,
    },
  ];
};

export default useProcedureSearchColumns;
